import { AppConfiguration } from "../app-configuration";
export class AdaConfiguration {
    // ADA
    public static ricercaAda = AppConfiguration.SECURED + '/api/ada/ricercaAda/';
    public static getElencoAda = AppConfiguration.SECURED + '/api/ada/getElencoAda/';
    public static ricercaAdaByIdProfilo = AppConfiguration.SECURED + '/api/ada/ricercaAdaByIdProfilo/';
    public static salvaAdaByIdProfilo = AppConfiguration.SECURED + '/api/ada/salvaAdaByIdProfilo/';
    public static eliminaAdaByIdProfilo = AppConfiguration.SECURED + '/api/ada/eliminaAdaByIdProfilo/';
    public static ricercaAdaByIdCompetenza = AppConfiguration.SECURED + '/api/ada/ricercaAdaByIdCompetenza/';
    public static salvaAdaByIdCompetenza = AppConfiguration.SECURED + '/api/ada/salvaAdaByIdCompetenza/';
    public static eliminaAdaByIdCompetenza = AppConfiguration.SECURED + '/api/ada/eliminaAdaByIdCompetenza/';
    public static getCodiciAdaByIdProposta = AppConfiguration.SECURED + '/api/getCodiciAdaByIdProposta/';
    public static getCodiciAdaByIdCompetenza = AppConfiguration.SECURED + '/api/getCodiciAdaByIdCompetenza/';
}